import type {PS, PublicMethodUtils} from '@wix/document-services-types'
import type {ComponentBoundingBox} from '@wix/viewer-manager-interface'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {getter, dataManipulation, immediate} = publicMethodUtils.extensionPublicAPI

    return {
        methods: {
            components: {
                innerElements: {
                    setManifests: immediate('builderComponents.setManifests'),
                    getInnerElementBoundingBoxes: publicMethodUtils.defineGetter(
                        (ps: PS, path: string[]): ComponentBoundingBox[] =>
                            ps.siteAPI.getInnerElementBoundingBoxes(path)
                    ),
                    serializeInnerElementPath: getter('innerElements.serializeInnerElementPath'),
                    cssStyle: {
                        get: getter('innerElements.getInnerElementStyle'),
                        update: dataManipulation('innerElements.setInnerElementStyle'),
                        remove: dataManipulation('innerElements.removeInnerElementStyleProperties'),
                        connectToGlobalStyle: dataManipulation('innerElements.connectToGlobalStyle')
                    },
                    data: {
                        get: getter('innerElements.getInnerElementData'),
                        getTranslationOverrides: getter('innerElements.getInnerElementTranslationOverrides'),
                        set: dataManipulation('innerElements.setInnerElementData'),
                        removeTranslationOverrides: dataManipulation(
                            'innerElements.removeInnerElementTranslationOverrides'
                        ),
                        removeTranslationOverridesForAField: dataManipulation(
                            'innerElements.removeInnerElementTranslationOverridesForAField'
                        ),
                        removeProperties: dataManipulation('innerElements.removeInnerElementDataProperties')
                    },
                    slots: {
                        populate: dataManipulation('innerElements.setInnerElementSlots', {
                            getReturnValueMethodPath: 'slots.getComponentToAddRef'
                        }),
                        get: getter('innerElements.getInnerElementSlots')
                    },
                    presets: {
                        get: getter('innerElements.getInnerElementPresets'),
                        set: dataManipulation('innerElements.setInnerElementPresets')
                    }
                }
            }
        }
    }
}
